<script setup lang="ts">
defineProps<{
  open: boolean
  name: string
}>()
const emit = defineEmits<{
  (e: 'onClose'): void
}>()
</script>

<template>
  <glx-modal :open="open">
    <section class="container">
      <img src="/img/policy/img/block1_授权单位查询结果.png" alt='项目查询结果'/>

      <div class="nameFloor">
        <div class="name">
          {{ name }}
        </div>
      </div>

      <div class="btnFloor">
        <button class="btnConfirm" @click="emit('onClose')">
          确定
        </button>
      </div>
    </section>
  </glx-modal>
</template>

<style scoped lang="scss">
section.container {
  width: 944px;
  height: 199px + 215px;

  position: absolute;
  top: 280px;
  left: 50%;
  transform: translateX(-50%);

  .imgTitle {
    object-fit: none;
  }

  > .nameFloor {
    position: absolute;
    left: 0;
    right: 0;
    top: 114px;
    text-align: center;
    z-index: 10;

    > .name {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 38px;
      color: #FFFFFF;
      line-height: 1;
    }
  }

  > .btnFloor {
    position: absolute;
    bottom: 35px;
    left: 0;
    right: 0;

    display: flex;
    justify-content: center;

    z-index: 10;

    > .btnConfirm {
      width: 246px;
      height: 50px;
      background: #FF0000;
      border-radius: 6px;

      font-family: PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 50px;
    }
  }
}
</style>